import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, LogIn } from "lucide-react";
import { api, EDX } from "@/lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("edx_admin_token", res.data.token);
      localStorage.setItem("edx_admin_email", res.data.email);
      toast.success("Welcome back, " + res.data.email);
      nav("/admin/dashboard");
    } catch { toast.error("Invalid email or password"); }
    finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen flex items-center justify-center px-4 relative" data-testid="admin-login-page">
      <div className="absolute inset-0 edx-grid opacity-30" />
      <div className="absolute inset-0 edx-aurora-bg" />
      <div className="relative w-full max-w-md glass glass-edge p-8 md:p-10">
        <div className="flex items-center gap-3 mb-8">
          <img src={EDX.logo} alt="EDENOX" className="h-12 w-12 rounded-xl" />
          <div>
            <div className="font-display font-bold gradient-text text-xl">EDENOX</div>
            <div className="text-[10px] uppercase tracking-widest text-edx-muted font-mono">Admin Console</div>
          </div>
        </div>
        <h1 className="display text-3xl text-white">Admin login</h1>
        <p className="mt-2 text-sm text-edx-muted">Access leads, bookings & analytics.</p>
        <form onSubmit={submit} className="mt-7 space-y-4" data-testid="admin-login-form">
          <div>
            <label className="text-[11px] uppercase tracking-widest text-edx-muted block mb-2 font-mono">Email</label>
            <div className="relative">
              <Mail size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-edx-muted" />
              <input data-testid="admin-email" type="email" className="edx-input pl-9" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-widest text-edx-muted block mb-2 font-mono">Password</label>
            <div className="relative">
              <Lock size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-edx-muted" />
              <input data-testid="admin-password" type="password" className="edx-input pl-9" value={password} onChange={(e) => setPassword(e.target.value)} required />
            </div>
          </div>
          <button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn btn-primary w-full disabled:opacity-60">
            {loading ? "Signing in..." : "Sign in"} <LogIn size={14} />
          </button>
        </form>
        <p className="mt-5 text-xs leading-relaxed text-edx-muted">
          Sign in at <span className="text-edx-cyan">/admin</span> using the administrator email and password configured securely in the backend environment.
        </p>
      </div>
    </main>
  );
}
